import React from "react";

const Markup = ({
    renderField,
    renderDateField,
    renderSelect,
    Button,
    counterpartyIds,
    lastName,
    firstName,
    patronymic,
    phoneNumber,
    passportIssuingCountry,
    passportSeries,
    passportNumber,
    passportIssuedBy,
    passportDateOfIssue,
    passportSubdivisionCode,
    licenseIssuingCountry,
    licenseSeries,
    licenseNumber,
    licenseDateOfIssue,
    licenseExpirationDate,
}) => {
    return (
        <div>
            {renderSelect(counterpartyIds)}
            {renderField(lastName)}
            {renderField(firstName)}
            {renderField(patronymic)}
            {renderField(phoneNumber)}
            <div className="form-group mt-3 mb-2">
                <strong>Паспортные данные</strong>
            </div>
            {renderSelect(passportIssuingCountry)}
            {renderField(passportSeries)}
            {renderField(passportNumber)}
            {renderField(passportIssuedBy)}
            {renderDateField(passportDateOfIssue)}
            {renderField(passportSubdivisionCode)}
            <div className="form-group mt-3 mb-2">
                <strong>Водительское удостоверение</strong>
            </div>
            {renderSelect(licenseIssuingCountry)}
            {renderField(licenseSeries)}
            {renderField(licenseNumber)}
            {renderDateField(licenseDateOfIssue)}
            {renderDateField(licenseExpirationDate)}
            {!!Button && <Button />}
        </div>
    );
};

export default Markup;
